import { ref, onMounted } from "vue";
import { templateRef } from "@vueuse/core";
import { useScrollTriggerAnimation } from "/composables/useScrollTriggerAnimation";


export default {
  __name: 'index',
  props: {
  dataProvider: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const dateISO8601 = props.dataProvider.date.replace(/ /g, "T");
const getWWDate = ref(new Date(dateISO8601).toDateString());

const getITDate = ref(
  new Date(dateISO8601).toLocaleString("it-IT", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  })
);
const { unveilText, reveal } = useScrollTriggerAnimation();
const tpl_overline = templateRef("tpl_overline");
const tpl_titleWrapper = templateRef("tpl_titleWrapper");
const tpl_title = templateRef("tpl_title");

onMounted(() => {
  reveal(tpl_overline.value, tpl_overline.value, "right", {
    useChildren: true,
    stagger: "short",
    intensity: "weak",
    fade: true,
    duration: "quick",
  });

  unveilText(tpl_title.value, tpl_titleWrapper.value, "bottom", {
    textTarget: "words",
    intensity: "strong",
    stagger: "wide",
    duration: "normal",
  });
});

return { __sfc: true,props, dateISO8601, getWWDate, getITDate, unveilText, reveal, tpl_overline, tpl_titleWrapper, tpl_title }
}

}